<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page06">
<p class="dedicationText">To Patty Sowell, the miracle of our house,<br/> with gratitude</p></a></div>
<a id="page06">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// boughtthegreeksbaby_ded01.vue?9a87665a